export default __webpack_public_path__ + "static/media/training_hover.d7d91195.png";